import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {AssuntoDTO} from "../../../../entity/AssuntoDTO";
import {AuthService} from "../../../../service/autenticacao/auth.service";
import {FaleComRhService} from "../../../../service/fale-com-rh/fale-com-rh.service";
import {Router} from "@angular/router";
import {FaleComRhFormFactory} from "../../../../service/fale-com-rh/fale-com-rh-form-factory.service";
import {FaleComRhBaseComponent} from "../common/fale-com-rh-base.component";
import {OK_PROTOCOLO_MANIFESTACAO_CODIGO, OK_PROTOCOLO_RASCUNHO_MANIFESTACAO_CODIGO} from "../../../../tools/Mensagens";
import {PAGINA_HOME_USUARIO_INTERNO} from "../../../../tools/URL";
import {ResponseHandler} from "../../../../entity/ResponseHandlerDTO";
import { normalizeSolicitacaoDocumentoFormValue } from "../partials/solicitacao-documento/solicitacao-documento.config";

@Component({
  selector: 'app-fale-com-rh-operador',
  templateUrl: './fale-com-rh-operador.component.html',
  styleUrls: ['./fale-com-rh-operador.component.css']
})
export class FaleComRhOperadorComponent extends FaleComRhBaseComponent implements OnChanges {

  @Input() temaSelecionado!: AssuntoDTO;
  @Input() demandaRecebida: string;
  @Input() nomeManifestante: string;
  @Input() emailManifestante: string;
  @Input() prioridadePessoaIdosaManifestante: boolean = false;
  @Input() faleComRh: any;
  @Input() status!: number;
  @Input() arquivosSalvos!: any[];

  role = 'servidor';
  identificadorSelecionado = 'servidor';
  formSubmitted = false;
  readonly = false;




  constructor(
    auth: AuthService,
    factory: FaleComRhFormFactory,
    private service: FaleComRhService,
    private router: Router
  ) {
    super(auth, factory);
    this.preencherDadosComDadosDaSesaoAutomaticamente = false;
    //Painel operador o nome do solicitante vem do formulario. Garante que o dado esteja vazio e que em faze de mudanças receba os dados do formulario
    this.form.get('nome').setValue('');
    this.form.get('email').setValue('');

  }

  ngOnInit() {
    super.ngOnInit();
    let assunto = this.temaSelecionado.value;
    this.setTema(assunto);
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.readonly = this.status == 1;

    if (changes['temaSelecionado'] && changes['temaSelecionado'].currentValue) {
      let assunto = changes['temaSelecionado'].currentValue.value;
      this.setTema(assunto);
    }

    if (changes['faleComRh'] && changes['faleComRh'].currentValue) {
      this.preencherFormularioEdicao(this.faleComRh);
    }


    if (changes['nomeManifestante'] && changes['nomeManifestante'].currentValue != null) {
      this.form.get('nome').setValue(this.nomeManifestante);
    }
    if (changes['emailManifestante'] && changes['emailManifestante'].currentValue != null) {
      this.form.get('email').setValue(this.emailManifestante);
    }
    if (changes['prioridadePessoaIdosaManifestante']
      && changes['prioridadePessoaIdosaManifestante'].currentValue != null) {
      this.form.get('prioridadePessoaIdosa').setValue(
        changes['prioridadePessoaIdosaManifestante'].currentValue === true
      );
    }
    if (changes['demandaRecebida'] && changes['demandaRecebida'].currentValue  != null) {
      this.form.get('demandaRecebida').setValue(this.demandaRecebida);
    }
  }

  setTema(assunto: any){
    if (assunto === 'alteracao_dados_cadastrais') {
      this.form.get('tipoAssunto').setValue('cadastral');
    } else if (assunto === 'alteracao_de_conta_bancaria') {
      this.form.get('tipoAssunto').setValue('conta');
    } else if (assunto === 'solicitacao_de_documentos' || assunto === 'solicitacao_documentos') {
      this.form.get('tipoAssunto').setValue('solicitacaoDocumentos');
    } else {
      this.form.get('tipoAssunto').setValue('obito');
    }
  }

  submit(enviar: boolean, manifesto: { id: number; ordem: number; codigo: string }) {
    this.formSubmitted = true;
    this.form.markAllAsTouched();

    if (this.form.invalid) {
      alert('Preencha os campos obrigatórios');
      return;
    }

    let raw = this.form.getRawValue();
    let tipoAssunto = this.mapTipoAssunto(raw.tipoAssunto);

    let payload = {
      id: raw.id,
      nome: raw.nome,
      email: raw.email,
      prioridadePessoaIdosa: raw.prioridadePessoaIdosa === true,
      username: raw.username,
      tipoSolicitante: this.mapTipoSolicitante(raw.tipoSolicitante),
      procedimentoFeitoPorTerceiro: !!raw.procedimentoFeitoPorTerceiro,
      representanteLegal: raw.procedimentoFeitoPorTerceiro ? {
        nomeCompleto: raw.nomeRepresentanteLegal,
        cpf: raw.cpfRepresentanteLegal
      } : null,
      demandaRecebida: raw.demandaRecebida,
      tipoAssunto: tipoAssunto,
      mensagem: this.getMensagem(raw),
      dadosCadastrais: null,
      contaBancaria: null,
      obito: null,
      solicitacaoDocumento: null,
      anexos: this.mapearAnexos(this.getGrupoNome(tipoAssunto)),
      anexosRepresentanteLegal: this.mapearAnexosRepresentanteLegal()
    };

    let dadosExtras = this.mapearDadosPorAssunto(tipoAssunto, raw);

    for (let key in dadosExtras) {
      payload[key] = dadosExtras[key];
    }

    const chamarFormularioSalvar = (this.form.get('id') != null || this.form.get('id') != undefined) && (this.form.get('id').value == null);

    if(chamarFormularioSalvar){
      this.service.salvar(payload, enviar).subscribe(retorno => {
        this.acaoRetorno(retorno, manifesto, enviar);
      });
    }else{
      this.service.atualizar(this.form.get('id').value, payload, enviar).subscribe(retorno => {
        this.acaoRetorno(retorno, manifesto, enviar);
      });
    }
  }

  preencherFormularioEdicao(data: any) {
    if (!data) return;

    // Campos base
    this.form.patchValue({
      id: data.id,
      nome: data.nome,
      email: data.email,
      prioridadePessoaIdosa: data.prioridadePessoaIdosa === true,
      tipoSolicitante: this.mapTipoSolicitanteReverse(data.tipoSolicitante),
      procedimentoFeitoPorTerceiro: !!data.procedimentoFeitoPorTerceiro,
      nomeRepresentanteLegal: data.representanteLegal ? data.representanteLegal.nomeCompleto : data.nomeRepresentanteLegal,
      cpfRepresentanteLegal: data.representanteLegal ? data.representanteLegal.cpf : data.cpfRepresentanteLegal,
      demandaRecebida: data.demandaRecebida,
    });

    this.arquivosSalvosRepresentanteLegal = data.anexosRepresentanteLegal || [];

    // Define tipo assunto e cria o grupo correto
    const tipo = this.mapTipoAssuntoReverse(data.tipoAssunto);
    var tipoAssuntoControl = this.form.get('tipoAssunto');

    if (tipoAssuntoControl) {
      tipoAssuntoControl.setValue(tipo);
    }

    // Aguarda o grupo ser criado antes de popular
    setTimeout(() => {
      this.preencherGrupoPorAssunto(tipo, data);
    });
    // Aguarda o grupo ser criado antes de popular

  }
  mapTipoAssuntoReverse(tipo: number): string {
    const map = {
      1: 'cadastral',
      2: 'conta',
      3: 'obito',
      4: 'solicitacaoDocumentos'
    };
    return map[tipo];
  }

  mapTipoSolicitanteReverse(tipo: number): string {
    const map = {
      1: 'servidor',
      2: 'magistrado',
      3: 'representante'
    };
    return map[tipo];
  }
  preencherGrupoPorAssunto(tipo: string, data: any) {
    switch (tipo) {

      case 'cadastral':
        if (data.dadosCadastrais && this.dadosCadastraisGroup) {
          this.dadosCadastraisGroup.patchValue(data.dadosCadastrais);
        }
        break;

      case 'conta':
        if (data.contaBancaria && this.contaBancariaGroup) {
          this.contaBancariaGroup.patchValue(data.contaBancaria);
        }
        break;

      case 'obito':
        if (data.obito && this.obitoGroup) {
          this.obitoGroup.patchValue(data.obito);
        }
        break;

      case 'solicitacaoDocumentos':
        if (data.solicitacaoDocumento && this.solicitacaoDocumentoGroup) {
          this.solicitacaoDocumentoGroup.patchValue(normalizeSolicitacaoDocumentoFormValue(data.solicitacaoDocumento));
        }
        break;
    }
  }

  private acaoRetorno(retorno: ResponseHandler, manifesto: {
    id: number;
    ordem: number;
    codigo: string
  }, enviar: boolean) {
    if (retorno.data) {
      if (enviar) {
        alert(OK_PROTOCOLO_MANIFESTACAO_CODIGO(manifesto.codigo + retorno.data.id));
      } else {
        alert(OK_PROTOCOLO_RASCUNHO_MANIFESTACAO_CODIGO(manifesto.codigo + retorno.data.id));
      }
      this.router.navigate([PAGINA_HOME_USUARIO_INTERNO]);
    }
  }
}
